// Angular
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from "@angular/router";
import { inject, Injectable } from "@angular/core";

// Services
import { AuthService } from "#services/auth/auth.service";

// Others
import { AUTH_PATH } from "#src/app/shared/variables/routes";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate {
    private authService = inject(AuthService);
    private router = inject(Router);

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        const isLoggedIn = await this.authService.isLoggedIn();

        if (state.url === `/${AUTH_PATH}`) {
            return isLoggedIn ? this.router.createUrlTree(["/"]) : true;
        }

        if (!isLoggedIn) {
            return this.router.createUrlTree([`/${AUTH_PATH}`]);
        }

        return true;
    }
}
